import {renderNotice} from '../services/render-notice.service'

export default class ManageTravelBookActionsComponent {
    constructor() {
        if ($('[data-travel-book-action-wrapper]').length > 0) {
            this.handleRemoveButton()
            this.handlePrintButton()
            this.handleSendButton()
        }

        if ($('[data-iris-travel-book-map-element]').length > 0) {
            this.handleMap()
        }
    }

    handleRemoveButton() {
        $('[data-travel-book-action-remove]').on('click', async (e) => {
            $('[data-travel-book-action-remove]').off('click')
            await this.onClickRemoveButton(e.currentTarget)
            this.handleRemoveButton()
        })
    }

    async onClickRemoveButton(target) {
        $(target).find('[data-travel-book-button-loader]').toggleClass('hidden')
        const query = await fetch(
            `${IrisTravelBookSettings.iris_travel_book_api_base_url}/remove-travel-book`,
        )
        const dataReturned = await query.json()
        $(target).find('[data-travel-book-button-loader]').toggleClass('hidden')

        if (query.status === 200) {
            const theTravelBookEvent = new CustomEvent('manage_travel_book', {
                detail: {count: dataReturned.travel_book.length},
            })
            window.dispatchEvent(theTravelBookEvent)

            $('[data-travel-book-content-wrapper]').html(dataReturned.html_content)
            if ($('[data-travel-book-counter]').length > 0) {
                $('[data-travel-book-counter]').html('0')
            }
        }
    }

    handlePrintButton() {
        $('[data-travel-book-action-print]').on('click', async (e) => {
            $('[data-travel-book-action-print]').off('click')
            await this.onClickPrintButton(e.currentTarget)
            this.handlePrintButton()
        })
    }

    async onClickPrintButton(target) {
        $(target).toggleClass('in-progress')
        const query = await fetch(
            `${IrisTravelBookSettings.iris_travel_book_api_base_url}/print-travel-book${IrisTravelBookSettings.iris_travel_book_api_args}`,
        )
        const dataReturned = await query.json()
        $(target).toggleClass('in-progress')

        if (query.status === 200) {
            if (!window.ActiveXObject) {
                const save = document.createElement('a')
                save.href = dataReturned.fileurl
                save.target = '_blank'
                save.download = dataReturned.filename.substring(
                    dataReturned.filename.lastIndexOf('/') + 1,
                )
                if (
                    navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
                    navigator.userAgent.search('Chrome') < 0
                ) {
                    document.location = save.href
                } else {
                    const evt = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                    })
                    save.dispatchEvent(evt)
                    ;(window.URL || window.webkitURL).revokeObjectURL(save.href)
                }
            } else if (!!window.ActiveXObject && document.execCommand) {
                const _window = window.open(dataReturned.fileurl, '_blank')
                _window.document.close()
                _window.document.execCommand('SaveAs', true, dataReturned.filename)
                _window.close()
            }
        } else {
            renderNotice('print', 'error')
        }
    }

    handleSendButton() {
        $('[data-travel-book-action-send-form]').on('submit', async (e) => {
            e.preventDefault()
            $('[data-travel-book-action-send-form]').off('submit')
            await this.onClickSendButton()
            this.handleSendButton()
        })
    }

    async onClickSendButton() {
        if ($('[data-travel-book-action-send-form] [name="recipient"]').val() !== '') {
            $('[data-travel-book-action-send] [data-travel-book-button-loader]').toggleClass(
                'hidden',
            )
            const query = await fetch(
                `${IrisTravelBookSettings.iris_travel_book_api_base_url}/send-travel-book?recipient=${$('[data-travel-book-action-send-form] [name="recipient"]').val()}`,
            )
            const dataReturned = await query.json()
            $('[data-travel-book-action-send] [data-travel-book-button-loader]').toggleClass(
                'hidden',
            )

            if (query.status === 200) {
                renderNotice('send', 'success')
                $('[data-travel-book-action-send-form] [name="recipient"]').val('')
                //HcModal.close(false); TODO
                $(document).find('[data-travel-book-action-send-form] .is-close').trigger('click')
            } else {
                renderNotice('send', 'error')
            }
        }
    }

    handleMap() {
        $('[data-travel-book-action-map]').on('click', () => {
            $('body').toggleClass('travel-book-map-open')
        })
    }
}
